module.exports = __webpack_public_path__ + "static/media/slide20_image.ed285321.png";